module.exports = require("././release/angular-ui-router.js");


//////////////////
// WEBPACK FOOTER
// angular-ui-router (bower component)
// module id = 1018
// module chunks = 1